import { useQuestTypeConfig } from "Infrastructure/Helpers/useQuestTypeConfig";
import { Chip, useTheme } from "@mui/material";
import type { FC } from "react";

interface QuestTypeCellProps {
  type: string;
}

export const QuestTypeCell: FC<QuestTypeCellProps> = ({ type }) => {
  const { customFontWeight, colors } = useTheme();
  const questTypeConfig = useQuestTypeConfig();
  const config = questTypeConfig[type as keyof typeof questTypeConfig];

  if (!config) {
    return <span>{type}</span>;
  }

  return (
    <Chip
      icon={<config.icon size={16} />}
      label={config.label}
      size="small"
      sx={{
        backgroundColor: colors.background.tertiary,
        color: colors.text.primary,
        fontWeight: customFontWeight.medium,
        textAlign: "left",
        "& .MuiChip-icon": { color: colors.text },
      }}
    />
  );
};
